<template>
<div>
     <v-data-table :search="search" :single-select="singleSelect" v-model="selected" show-select :footer-props="{
            showFirstLastPage: true,
            firstIcon: 'mdi-arrow-collapse-left',
            lastIcon: 'mdi-arrow-collapse-right',
            prevIcon: 'mdi-minus',
            nextIcon: 'mdi-plus',
          }" :headers="headers" class="elevation-1 mt-0 px-5" :items="demande" :height="inerHeight">

          <template v-slot:top>
               <v-toolbar flat color="white">
                    <v-toolbar-title style="font-size: 25px">{{$t('rendVous') + ':'}}</v-toolbar-title>
                    <v-spacer></v-spacer>

                    <v-autocomplete class="ma-4 mt-11" :items="isView" clearable dense v-model="filters.isShow" :label="$t('isView')" :item-text="localLang=='fr' ? 'isView' : 'isViewAr'" item-value="id" outlined></v-autocomplete>

                    <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="10" transition="scale-transition" offset-y min-width="240px">
                         <template v-slot:activator="{ on }">
                              <v-text-field class="ma-4" @click:clear="clirtext" dense hide-details outlined v-model="dateRangeText" :label="$t('dateDF')" clearable readonly v-on="on"></v-text-field>
                         </template>
                         <v-date-picker v-model="filters.date_rendez_vous" range></v-date-picker>
                    </v-menu>

                    <v-tooltip bottom>
                         <template v-slot:activator="{ on }">
                              <v-btn @click="deleteMulti" v-on="on" class="ma-2" hide-details tile color="red">
                                   <v-icon color="white" size="30">mdi-delete-sweep</v-icon>
                              </v-btn>
                         </template>
                         <span>{{ $t('deleteMulti') }}</span>
                    </v-tooltip>

               </v-toolbar>
          </template>

          <template v-slot:item.date_rendez_vous="{ item }">
               <v-chip dark color="grey lighten-1" v-if="item.date_rendez_vous == '1111-11-11'">/</v-chip>
               <v-chip dark color="blue lighten-2" v-else>{{ item.date_rendez_vous }}</v-chip>
          </template>
          <template v-slot:item.created_at="{ item }">
               <v-chip dark color="grey lighten-0">{{ item.created_at | moment }}</v-chip>
          </template>
          <template v-slot:item.isShow="{ item }">
               <v-chip dark color="red lighten-1" v-if="item.isShow == '0'">
                    <v-icon>mdi-eye-off</v-icon>
               </v-chip>
               <v-chip dark color="green lighten-2" v-else>
                    <v-icon>mdi-eye</v-icon>
               </v-chip>
          </template>
          <template v-slot:item.file="{ item }">
               <span v-if="item.file != '/'" @click="showPDF(item)" class="btnShowModal">{{ item.file }}</span>
               <span v-if="item.file == '/'">
                    <v-icon color="red">mdi-close</v-icon>
               </span>
          </template>

          <template v-slot:item.action="{ item }">
               <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                         <v-btn v-on="on" icon color="green" @click="updateResponse(item)">
                              <v-icon size="30"> mdi-timeline-clock-outline </v-icon>
                         </v-btn>
                    </template>
                    <span>{{ $t('response') }}</span>
               </v-tooltip>

               <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                         <v-btn v-on="on" icon color="red" @click="removeItem(item)">
                              <v-icon size=30>mdi-delete-outline </v-icon>
                         </v-btn>
                    </template>
                    <span>{{ $t('supprimer') }}</span>
               </v-tooltip>

          </template>
     </v-data-table>

     <v-dialog v-model="dialog" persistent max-width="900">
          <v-card>
               <v-card-title class="headline">
                    {{ $t('acceptRend')  }}
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                         <template v-slot:activator="{ on }">
                              <v-btn v-on="on" color="red" outlined icon @click="close()" class="mt-1 mr-2">
                                   <v-icon>mdi-close</v-icon>
                              </v-btn>
                         </template>
                         <span>{{ $t('close') }}</span>
                    </v-tooltip>
               </v-card-title>
               <v-card-text>
                    <v-row>
                         <v-col cols="12" lg="6" md="6" sm="12">
                              <v-col cols="12">
                                   <v-text-field class="ma-0" dense hide-details v-model="form.nom" outlined :label="$t('nom')"  append-icon="mdi-account-outline" readonly></v-text-field>
                              </v-col>
                              <v-col cols="12">
                                   <v-text-field class="ma-0" dense hide-details outlined v-model="form.email" :label="$t('email')"  append-icon="mdi-email-outline" readonly></v-text-field>
                              </v-col>
                              <v-col cols="12">
                                   <v-textarea outlined rows="3" hide-details v-model="form.message" readonly  append-icon="mdi-message-outline" :label="$t('msg')"></v-textarea>
                              </v-col>
                         </v-col>
                         <v-col cols="12" lg="6" md="6" sm="12">
                              <v-col cols="12">
                                   <v-menu v-model="menu3" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                                        <template v-slot:activator="{ on, attrs }">
                                             <v-text-field hide-details outlined dense v-model="form.date_rendez_vous" label="Picker without buttons" append-icon="mdi-calendar-check" readonly v-bind="attrs" v-on="on"></v-text-field>
                                        </template>
                                        <v-date-picker v-model="form.date_rendez_vous" @input="menu3 = false"></v-date-picker>
                                   </v-menu>
                              </v-col>
                              <v-col cols="12">
                                   <v-textarea outlined rows="5" v-model="form.reponse" class="mt-2" hide-details clearable  append-icon="mdi-replay" :label="$t('response')"></v-textarea>
                              </v-col>
                         </v-col>
                    </v-row>
               </v-card-text>
               <v-card-actions hide-details>
                    <v-spacer></v-spacer>
                    <v-btn  v-if="!loading" color="green darken-1"  class="ma-2" dark   @click="saveDemande">{{ $t('save') }}</v-btn>
                     <span class="pa-2"  v-else>{{ $t('patienter') }}</span>
               </v-card-actions>
          </v-card>
     </v-dialog>

     <v-dialog class="" v-model="dialog15" max-width="700">
          <v-card>
               <v-card-title class="headline ">{{ $t('voResult') }}</v-card-title>
               <v-card-text>
                    <iframe :src="infoPdf.file | URL3" width="100%" height="600"></iframe>
               </v-card-text>
               <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" text @click="dialog15 = false">{{ $t('close') }}</v-btn>
               </v-card-actions>
          </v-card>
     </v-dialog>
</div>
</template>

<script>
export default {
     data: () => ({
          form: {},
          loading: false, 
          dialog: false,
          date: new Date().toISOString().substr(0, 10),
          infoPdf: {},
          menu2: false,
          menu3: false,
          filters: {
               isShow: '',
               date_rendez_vous: [],
          },
          isView: [{
                    id: 0,
                    isView: 'Non vue',
                    isViewAr: 'لم يتم رؤيتها',
               },
               {
                    id: 1,
                    isView: 'Vue',
                    isViewAr: 'تم رؤيتها',
               },
          ],
          dialog15: false,
          search: '',
          singleSelect: false,
          selected: [],
          inerHeight: window.innerHeight - 290,
          headers: [{
                    text: localStorage.getItem('lang') == 'fr' ? 'Le nom' : 'الإسم',
                    value: 'nom',
                    align: 'center',
                    sortable: false
               },
               {
                    text: localStorage.getItem('lang') == 'fr' ? 'E-mail' : 'البريد الإلكتروني',
                    value: 'email',
                    align: 'center',
                    sortable: false
               },
               {
                    text: localStorage.getItem('lang') == 'fr' ? 'Téléphone' : 'الهاتف',
                    value: 'telephone',
                    align: 'center',
                    sortable: false
               },
               //  {
               //       text: localStorage.getItem('lang') == 'fr' ? 'Message' : 'الرسالة',
               //       value: 'message',
               //       align: 'center',
               //       sortable: false
               //  },
               {
                    text: localStorage.getItem('lang') == 'fr' ? 'Fichier' : 'الملف',
                    value: 'file',
                    align: 'center',
                    sortable: false
               },
               {
                    text: localStorage.getItem('lang') == 'fr' ? 'Réponse' : 'الرد',
                    value: 'reponse',
                    align: 'center',
                    sortable: false
               },
               {
                    text: localStorage.getItem('lang') == 'fr' ? 'Date de rendez-vous' : 'تاريخ الموعد',
                    value: 'date_rendez_vous',
                    align: 'center',
                    sortable: false
               },
               {
                    text: localStorage.getItem('lang') == 'fr' ? 'Vue' : 'تم الرؤية',
                    value: 'isShow',
                    align: 'center',
                    sortable: false
               },
               {
                    text: localStorage.getItem('lang') == 'fr' ? 'Date de demande' : 'تاريخ الطلب',
                    value: 'created_at',
                    align: 'center',
                    sortable: false
               },
               {
                    text: localStorage.getItem('lang') == 'fr' ? 'Action' : 'الحدث',
                    value: 'action',
                    align: 'center',
                    sortable: false
               },
          ],
     }),

     methods: {
          init() {
            this.form = {
              type: 1,
              nom: '',
              email: '',
              telephone: '',
              file: '',
              message: '',
              reponse: '', 
              date_rendez_vous: new Date().toISOString().substr(0, 10), 
              domainName: document.location.origin,
            }
          },
          saveDemande() {
            var url = 'getDemandes/addDemandes'
            var commit = 'getDemandes'
           this.loading = true
            this.$Register({data: JSON.stringify(this.form)}, url, commit).then((res) => {
                 this.init()
                 this.dialog = false
            }).then((res) => {
                    this.loading = false 
               }).catch((err) => {
                    this.loading = false
               })

          },
          clirtext(e) {
               this.filters.dateRangeText = ['', '']
          },
          showPDF(item) {
               this.dialog15 = true
               this.infoPdf = {},
                    console.log('item', item)
               this.infoPdf = item
          },
          updateResponse(data) {
               console.log(data);
               this.form = data
               this.form.type = 1
               this.form.date_rendez_vous = new Date().toISOString().substr(0, 10)
               this.form.types = 0

               this.dialog = true
               var url = 'getDemandes/changeVue'
               var commit = 'getDemandes'

               this.$Register({
                    data: JSON.stringify(data)
               }, url, commit)
               this.$store.dispatch('getDemandes')
          },
          removeItem(data) {
               this.$store.dispatch('deleteDemande', {
                    data: JSON.stringify(data)
               })
               this.$store.dispatch('getDemandes')
          },
          deleteMulti() {
               this.$store.dispatch('deleteDemande', {
                    data: JSON.stringify(this.selected)
               })
               this.$store.dispatch('getDemandes')
          },
          close() {
               this.dialog = false
          }
     },
     computed: {
          dateRangeText() {
               return this.filters.date_rendez_vous.join(' ~ ')
          },
          
          demande() {
               return new this.$MultiFilter(this.$store.state.demande.filter(e => e.types == 0), this.filters).filterData()
          }
     },
     created() {
          this.$store.dispatch('getMessage')
          this.$store.dispatch('getDemandes')
          this.init()
          window.addEventListener('resize', () => {
               this.inerHeight = window.innerHeight - 270
          })

          Fire.$on('search',(search) => {
               this.search = search
          } )
     }
}
</script>

<style>

</style>
